export default __webpack_public_path__ + "static/media/pp-b-3.86ae8af1.svg";